module.exports = __webpack_public_path__ + "img/msantos.da8ffbeb.png";